import BasicService from "./BasicService";

class TownshipService extends BasicService {
  constructor() {
    super();
  }
  getVoucherDataForPrint(ItemId) {
    const url = `/orders/${ItemId}/vouchers`;
    return this.axios.get(url).then(response => response.data);
  }
}

const townshipService = new TownshipService();
export default townshipService;
